import { LogoPropsType } from './logoTypes';

export default function TestcontainersLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg viewBox="0 0 68 78" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.8563 20.5035C67.8563 20.4727 67.8563 20.411 67.8563 20.3802C67.8563 20.2569 67.8563 20.1337 67.8255 20.0412C67.733 19.4556 67.3632 18.9625 66.8392 18.6543C66.7776 18.6234 66.716 18.5926 66.6543 18.5618L35.0014 0.254271C34.385 -0.0847571 33.6453 -0.0847571 33.0289 0.254271L1.12939 18.6543C0.512975 18.9933 0.143125 19.6713 0.143125 20.3802L0.112305 57.1802C0.112305 57.8891 0.482154 58.5363 1.09857 58.9062L32.9981 77.337C33.3063 77.5219 33.6453 77.6144 33.9843 77.6144H34.0151C34.3542 77.6144 34.6932 77.5219 35.0014 77.337L66.9009 58.9062C67.5173 58.5671 67.8871 57.8891 67.8871 57.1802L67.8563 20.5035Z"
        fill={monochrome ? 'currentColor' : '#361E5B'}
      ></path>
      <path
        d="M33.985 4.22998L4.08887 21.5204V56.0705L33.985 73.3301L63.912 56.0705V21.5204L33.985 4.22998Z"
        fill={monochrome ? 'currentColor' : '#16D6C7'}
      ></path>
      <path
        d="M63.9113 21.5205V56.0706L33.9844 73.3302V38.7801L63.9113 21.5205Z"
        fill={monochrome ? 'currentColor' : '#027F9E'}
      ></path>
      <path
        d="M63.912 21.5204L33.985 38.78L4.08887 21.5204L33.985 4.22998L63.912 21.5204Z"
        fill={monochrome ? 'currentColor' : '#17A6B2'}
      ></path>
    </svg>
  );
}
